// Libs
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ButtonSpocket } from "shared_components";
import moment from "moment";

// Components
import ModalWrapper from "../../ModalWrapper";
import Countdown from "../../Countdown/Countdown";

// Action
import { showModal } from "../../../../actions/ui";
import { trackPaywallView } from "../../../../actions/tracker";

// Images
import bulkCheckoutCards from "../../../../assets/unicorn-bc.png";
import unicornIcon from "../../../../assets/icon-unicorn.png";
import cardInvoice from "../../../../newDropshipperApp/images/card-invoice.png";
import fireInvoice from "../../../../newDropshipperApp/images/fire-invoice.png";
import crownPremium from "../../../../newDropshipperApp/images/crown-premium-products.png";
import cardPremium from "../../../../newDropshipperApp/images/premium-card.png";

// Utils
import {
  numberOfColumnsPerRow,
  calculatePositionForIndex
} from "../../../../utils/columns";

// Style
import "./UnicornFeatureModal.css";

const typeModal = {
  unicorn: {
    icon: unicornIcon,
    image: bulkCheckoutCards,
    title: "Save on the Unicorn Plan Today!",
    subtitle:
      "Upgrade to the Unicorn Plan to gain access to bulk order processing",
    btnText: "Upgrade NOW",
    classNameSvg: "UnicornFeatureModal__purple"
  },
  premiumProducts: {
    icon: crownPremium,
    image: cardPremium,
    title: "Save on Premium Plans Today!",
    subtitle: "Upgrade to the Pro Plan and sell more with Premium products",
    btnText: "Upgrade NOW",
    classNameSvg: "UnicornFeatureModal__blue"
  },
  invoice: {
    icon: fireInvoice,
    image: cardInvoice,
    title: "Save on Branded Invoicing Today!",
    subtitle:
      "Upgrade to the Pro Plan and build your brand with branded invoicing",
    btnText: "Upgrade NOW",
    classNameSvg: "UnicornFeatureModal__green"
  }
};

function UnicornFeatureModal({
  dataModal,
  showModal,
  trackPaywallView,
  currentPromotionEndTime,
  currentPromotionType
}) {
  useEffect(() => {
    const {
      referrerPage,
      referrerContext,
      referrerContextEntityId,
      referrerPosition
    } = dataModal;

    trackPaywallView(
      referrerPage,
      referrerContext,
      referrerContextEntityId || "",
      calculatePositionForIndex(referrerPosition),
      numberOfColumnsPerRow()
    );
  }, []);

  const getPromotionEndTimeFormated = () => {
    const date = moment
      .tz(currentPromotionEndTime, "America/Los_Angeles")
      .add(6, "hours")
      .format();
    return new Date(date).getTime();
  };

  const getCurrentTime = () => {
    const date = moment.tz(new Date(), "America/Los_Angeles").format();
    return new Date(date).getTime();
  };

  return (
    <ModalWrapper
      size={`UnicornFeatureModal__container ${
        typeModal[dataModal.type].classNameSvg
      }`}
    >
      <ModalWrapper.Header />
      {/*  */}
      <ModalWrapper.Body>
        <div className="UnicornFeatureModal__body">
          <div className="UnicornFeatureModal__left">
            <img src={typeModal[dataModal.type].icon} alt="Emoji" />
            {getPromotionEndTimeFormated() > getCurrentTime() && (
              <Countdown splitTime endDate={getPromotionEndTimeFormated()} />
            )}
            <div className="UnicornFeatureModal__title">
              {typeModal[dataModal.type].title}
              <span>{typeModal[dataModal.type].subtitle}</span>
            </div>
            <ButtonSpocket
              bsStyle="success"
              onClick={() => {
                showModal("UPGRADE_MODAL");
              }}
            >
              {typeModal[dataModal.type].btnText}
            </ButtonSpocket>
          </div>
          <div className="UnicornFeatureModal__right">
            <img
              src={typeModal[dataModal.type].image}
              alt="bulk checkout cards"
            />
          </div>
        </div>
      </ModalWrapper.Body>
    </ModalWrapper>
  );
}

UnicornFeatureModal.propTypes = {
  dataModal: PropTypes.object.isRequired,
  showModal: PropTypes.func.isRequired,
  trackPaywallView: PropTypes.func.isRequired,
  currentPromotionEndTime: PropTypes.string.isRequired,
  currentPromotionType: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const {
    current_promotion_type: currentPromotionType
  } = state.settings.dropshipperData;

  return {
    dataModal: state.ui.data,
    currentPromotionEndTime: localStorage.getItem("created_at"),
    currentPromotionType
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showModal, trackPaywallView }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnicornFeatureModal);



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/UnicornFeatureModal/UnicornFeatureModal.js